import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useGetPatientMainInsuranceInfo from '../../components/InsurancesInfo/hooks/useGetPatientMainInsuranceInfo';

import { selectInsuranceRelatedDataFetching } from '../../redux/manage-insurances/selectors/common';
import { manageInsurancesActions } from '../../redux/manage-insurances/actions/manage-insurances-actions';

const useGetPatientInsuranceData = ({
  userId,
  flowType,
  isInsuranceEditOpen,
}) => {
  const dispatch = useDispatch();

  const isInsuranceRelatedDataFetching = useSelector(
    selectInsuranceRelatedDataFetching,
  );

  const insuranceData = useGetPatientMainInsuranceInfo({ flowType });

  useEffect(() => {
    dispatch(
      manageInsurancesActions.downloadPatientInsurancesData({
        userId,
      }),
    );
  }, [userId, isInsuranceEditOpen]);

  return {
    insuranceData,
    isInsuranceRelatedDataFetching,
  };
};

export default useGetPatientInsuranceData;



// WEBPACK FOOTER //
// ./src/hooks/patientInsurance/useGetPatientInsuranceData.js